import Cookies from 'js-cookie'

import { IS_LOGGED_IN_COOKIE_NAME } from '@/lib/constants'

const publicPages = [
  '/',
  '/home-redesign',
  '/index.html',
  '/signin',
  '/forgot',
  '/logout',
  '/about',
  '/api-docs',
  '/terms',
  '/privacy',
  '/affiliates',
  '/plans',
  '/features',
  '/list-of-nsfw-subreddits'
]

const publicPagesWithAppendedSlash = publicPages.map((path) => (path += '/'))

export default ({ app }) => {
  app.router.beforeEach(async (to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const isPublicPage =
      publicPages.includes(to.path) ||
      publicPagesWithAppendedSlash.includes(to.path)
    const authRequired =
      !isPublicPage &&
      !to.path.startsWith('/analysis') &&
      !to.path.startsWith('/redditors') &&
      !to.path.startsWith('/use-cases') &&
      !to.path.startsWith('/solutions') &&
      !to.path.startsWith('/blog') &&
      !to.path.startsWith('/help') &&
      !to.path.startsWith('/reset-password') &&
      !to.path.startsWith('/confirm-email') &&
      !to.path.startsWith('/features')
    const firstPageLoad = !from.name
    const isLoggedInCookie = Cookies.get(IS_LOGGED_IN_COOKIE_NAME)

    if ((authRequired || isLoggedInCookie) && !app.store.state.profile) {
      await app.store.dispatch('getProfile')
    }

    if (firstPageLoad) {
      app.store.dispatch('finishedInitialLoad')
    }

    const isLoggedIn = app.store.getters.isLoggedIn

    if (isLoggedIn && to.path == '/') {
      next({ path: '/dashboard', query: to.query })
    } else if (authRequired && !isLoggedIn) {
      app.store.dispatch('logout')
      next({ path: '/signin', query: { next: to.path } })
    } else {
      // Make sure that the next function is called exactly once in any given pass through the navigation guard.
      // https://router.vuejs.org/guide/advanced/navigation-guards.html#global-before-guards
      next()
    }
  })
}
